import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Container, Header } from '~/components';
import { productFruitsIds } from '~/constants/productFruits';
import { routes } from '~/providers/RouterProvider/router.routes';

import { ClientsTable } from './ClientsTable';

export const ClientsOverview = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['clients']);

  return (
    <>
      <Header.Root>
        <Header.Content title={t('clients:header.title')} />

        <Header.Actions>
          <Header.Action data-pf-id={productFruitsIds.clients.header.createClient} icon="Add" onClick={() => navigate(routes.createClient)}>
            {t('clients:header.actionBlock.button')}
          </Header.Action>
        </Header.Actions>
      </Header.Root>

      <Container>
        <ClientsTable />
      </Container>
    </>
  );
};
